export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/PreviousIcon.83bbe4b2.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};